var _defs, _polygon, _rect, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1125({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:square;stroke-linejoin:round;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.77 6.14 13.77 10.61 3.57 10.61 3.57 11.95 15.1 11.95 15.1 6.14 13.77 6.14"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.9,
    y: 3.47,
    width: 11.53,
    height: 5.81
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "12.43 4.81 12.43 9.28 2.23 9.28 2.23 10.61 13.77 10.61 13.77 4.81 12.43 4.81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1125);
export default __webpack_public_path__ + "static/media/Symbolpack_1_125.8d8791958f4344c5d0c0ff3f9a61dff7.svg";
export { ForwardRef as ReactComponent };